import NotificationManager from './NotificationManager';

export { NotificationManager };
export default NotificationManager;
